import { END_POINTS } from '../constants/urls';
import emptySplitApi from '../utils/rtk';

interface CommonResponseType {
    statusCode: number;
    message: string;
}

export const storeApi = emptySplitApi.injectEndpoints({
    endpoints: (builder) => ({
        addStore: builder.mutation<CommonResponseType & { data?: any }, any>({
            query: (body) => ({
                url: END_POINTS.store,
                method: 'POST',
                body,
            }),
        }),
        updateStore: builder.mutation<
            CommonResponseType & { data?: any },
            { body: any, id: string }
        >({
            query: ({ body, id }) => ({
                url: `${END_POINTS.store}/${id}`,
                method: 'PUT',
                body,
            }),
        }),
        getStoreList: builder.query<
            CommonResponseType & {
                data: {
                    store: any[];
                    count: number;
                };
            },
            {
                page: number;
                limit: number;
                search?: string;
                status?: string;
            }
        >({
            query: ({ page, limit, search, status }) => ({
                url: `${END_POINTS.store}/list/?page=${page}&limit=${limit}${search ? `&search=${search}` : ''}${status !== '0' ? `&status=${status}` : ''}`,
                method: 'GET',
            }),
        }),
        getStoreById: builder.query<
            CommonResponseType & { data: any },
            { id: string }
        >({
            query: ({ id }) => ({
                url: `${END_POINTS.store}${id}`,
                method: 'GET',
            }),
        }),
        deleteStore: builder.mutation<
            CommonResponseType & { data?: any },
            { id: string }
        >({
            query: ({ id }) => ({
                url: `${END_POINTS.store}/${id}`,
                method: 'DELETE',
                body: {},
            }),
        }),
    }),
});

export const {
    useAddStoreMutation,
    useUpdateStoreMutation,
    useLazyGetStoreListQuery,
    useGetStoreByIdQuery,
    useLazyGetStoreByIdQuery,
    useDeleteStoreMutation,
} = storeApi;
